export enum Themes {
  pickup = "pickup",
  preferredPickupPartner = "preferredPickupPartner",
}
